import { IconRecycle, IconFlask, IconUsers, IconSparkles, IconLeaf, IconMapPin } from '@tabler/icons-react';
import './benefits.css';

const benefits = [
  { icon: IconRecycle, title: 'Menos plástico', desc: 'Opciones recargables y envases retornables. Generás menos residuos.' },
  { icon: IconFlask, title: 'Productos rendidores', desc: 'Concentrados y en formato polvo. Rinden más, gastás menos.' },
  { icon: IconUsers, title: 'Asesoramiento real', desc: 'Te explicamos qué usar y cómo. Sin letra chica, sin vueltas.' },
  { icon: IconSparkles, title: 'Limpieza efectiva', desc: 'Limpia igual o mejor que los productos comerciales, sin tóxicos.' },
  { icon: IconLeaf, title: 'Eco-friendly', desc: 'Biodegradables, libres de contaminantes y respetuosos con el ambiente.' },
  { icon: IconMapPin, title: 'Compra local', desc: 'Emprendimiento de Santa Rosa, La Pampa. Cerca tuyo, con atención personalizada.' },
];

function Benefits() {
  return (
    <section className="section benefits">
      <div className="container">
        <div className="benefits__header">
          <span className="section-label">Por qué EcoClean</span>
          <h2 className="section-title">Limpiar bien nunca fue tan consciente</h2>
        </div>
        <div className="benefits__grid">
          {benefits.map((b) => (
            <div key={b.title} className="card benefits__card">
              <div className="benefits__icon"><b.icon size={24} /></div>
              <h3 className="benefits__title">{b.title}</h3>
              <p className="benefits__desc">{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Benefits;
